export default {
  "nav_signin": "登录",
  "nav_account": "账户",
  "nav_signout": "退出",
  "hero_title": "智能数字解决方案",
  "hero_title_line1": "Infinity Business — 智能",
  "hero_title_line2": "数字解决方案",
  "hero_subtitle": "认识RisTA，您的智能数字合作伙伴",
  "hero_cta": "与RisTA对话",
  "hero_cta2": "查看服务",
  "b2b_title": "商业解决方案 (B2B)",
  "p2p_title": "个人解决方案 (P2P)",
  "b2b_desc": "网站、移动应用、软件、托管、设计和广告",
  "p2p_desc": "加密货币教育，投资工具，组织，翻译，品牌，域名",
  "services_title": "我们的服务",
  "services_subtitle": "从企业网站解决方案到个人投资工具。RisTA为您导航。",
  "cta_title": "准备好创造了吗？",
  "cta_subtitle": "与RisTA对话，获取个性化报价。",
  "about": "关于我们",
  "contact": "联系方式",
  "privacy": "隐私政策",
  "blog": "博客",
  "donate": "捐赠",
  "booking": "预约",
  "login_title": "欢迎回来",
  "register_title": "创建账户",
  "login_subtitle": "登录您的Infinity Business账户",
  "register_subtitle": "立即加入Infinity Business",
  "auth0_btn": "使用Auth0继续",
  "or_email": "或使用邮箱继续",
  "email": "电子邮件",
  "password": "密码",
  "full_name": "姓名",
  "signin_btn": "登录",
  "register_btn": "创建账户",
  "no_account": "没有账户？",
  "have_account": "已有账户？",
  "create_one": "创建一个",
  "sign_in": "登录",
  "pricing_title": "选择您的计划",
  "pricing_subtitle": "所有计划均包含RisTA访问权限。",
  "pay_stripe": "使用Stripe支付",
  "pay_mypos": "使用myPOS支付",
  "pay_crypto": "使用加密货币支付",
  "free_plan": "当前免费计划",
  "most_popular": "最受欢迎",
  "dashboard_title": "我的账户",
  "profile": "个人资料",
  "security": "安全 (2FA)",
  "subscription": "订阅",
  "upgrade": "升级",
  "change_plan": "更改计划",
  "twofa_title": "双因素认证",
  "setup_2fa": "设置2FA",
  "disable_2fa": "关闭2FA",
  "payment_success": "支付成功！",
  "payment_cancel": "支付取消",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. 保留所有权利。",
  "about_title": "关于 Infinity Business",
  "contact_title": "联系我们",
  "privacy_title": "隐私政策",
  "send_message": "发送消息",
  "trade_title": "我们为您交易",
  "trade_desc": "专业的加密货币交易服务。与我们聊天了解更多。",
  "back_home": "返回首页",
  "loading": "加载中...",
  "save": "保存",
  "session_expired": "会话已过期，请重新登录。",
  "nav_services": "服务",
  "nav_portal": "门户",
  "nav_credits": "积分",
  "hero_online": "在线",
  "hero_digital_partner": "数字合作伙伴",
  "business_solutions": "商业解决方案",
  "personal_solutions": "个人解决方案",
  "enterprise_desc": "专业数字服务助力企业成长。",
  "personal_desc": "智能投资工具和教育助力个人成长。",
  "services_hero_title": "我们的服务",
  "services_hero_desc": "从基础网站到高级智能解决方案，我们提供卓越的数字服务。",
  "get_started": "开始",
  "get_a_quote": "获取报价",
  "free_seo_audit": "免费SEO审计",
  "ready_to_start": "准备好开始了吗？",
  "ready_to_build": "准备好创造了吗？",
  "ready_to_build_sub": "与RisTA对话获取个性化报价。",
  "trusted_worldwide": "全球信赖",
  "chat_placeholder": "输入消息...",
  "chat_suggested_1": "我需要一个网站",
  "chat_suggested_2": "介绍一下服务",
  "chat_suggested_3": "我想要智能服务",
  "chat_suggested_4": "获取价格估算",
  "trust_platform": "可信赖的平台",
  "trust_security": "企业级安全",
  "trust_ai": "智能驱动",
  "trust_global": "全球覆盖",
  "back_to_home": "返回首页",
  "continue_google": "使用Google继续",
  "continue_facebook": "使用Facebook继续",
  "continue_github": "使用GitHub继续",
  "or_continue_email": "或使用邮箱继续",
  "two_factor_auth": "双因素认证",
  "enter_2fa_code": "输入认证器应用中的代码",
  "verify_btn": "验证代码",
  "verifying": "验证中...",
  "use_different_account": "使用其他账户",
  "session_expired_msg": "您的会话因不活动而过期。",
  "nav_home": "首页",
  "nav_back": "返回",
  "my_account": "我的账户",
  "sign_out": "退出",
  "client_portal": "客户门户",
  "your_projects": "您的项目",
  "your_invoices": "您的发票",
  "projects": "项目",
  "invoices_tab": "发票",
  "milestones": "里程碑",
  "messages": "消息",
  "no_projects": "暂无项目。",
  "no_invoices": "暂无发票。",
  "no_messages": "暂无消息。",
  "type_message": "输入消息...",
  "back_to_projects": "返回项目",
  "budget_label": "预算",
  "progress_label": "进度",
  "service_label": "服务",
  "portal_locked_desc": "客户门户仅供已批准的客户使用。",
  "contact_to_start": "联系我们开始",
  "quick_web_dev": "网站开发",
  "quick_mobile": "移动应用",
  "quick_crypto": "加密货币教育",
  "quick_get_quote": "获取报价",
  "quick_tell_more": "了解更多",
  "quick_have_project": "我有一个项目",
  "quick_submit": "提交请求",
  "get_cost_estimate": "费用估算",
  "choose_plan": "选择您的计划",
  "choose_plan_desc": "选择合适的计划来扩展您的业务。",
  "current_free_plan": "当前免费计划",
  "svc_ecommerce_label": "电子商务 / 网上商店",
  "svc_ecommerce_desc": "集成支付的完整在线商店",
  "svc_ecommerce_price": "起价 €799",
  "svc_seo_label": "SEO与数字营销",
  "svc_seo_desc": "搜索引擎优化和增长策略",
  "svc_seo_price": "起价 €299/月",
  "svc_hosting_label": "托管主机",
  "svc_hosting_desc": "安全、快速、可靠的托管基础设施",
  "svc_hosting_price": "起价 €29/月",
  "svc_advertising_label": "数字广告",
  "svc_advertising_desc": "PPC、社交广告和效果营销",
  "svc_advertising_price": "起价 €499/月",
  "svc_trading_label": "交易咨询",
  "svc_trading_desc": "专家指导的交易策略课程",
  "svc_trading_price": "起价 €149/次",
  "svc_domains_label": "域名管理",
  "svc_domains_desc": "域名注册、DNS管理和转移",
  "svc_domains_price": "起价 €19/年",
  "testimonials_title": "客户评价",
  "testimonials_subtitle": "深受欧洲企业信赖",
  "stat_projects": "已完成项目",
  "stat_satisfaction": "客户满意度",
  "stat_languages": "支持语言",
  "all_rights_reserved": "版权所有。",
  "form_your_name": "您的姓名",
  "form_your_email": "您的邮箱",
  "form_describe_need": "描述您的需求...",
  "form_additional_feedback": "其他反馈？（可选）",
  "form_email_followup": "您的邮箱（可选，用于跟进）",
  "form_budget_range": "预算范围",
  "form_timeline": "时间线",
  "form_cancel": "取消",
  "form_select_services": "选择服务（可多选）：",
  "rating_title": "评价您与RisTA的体验",
  "rating_helpful": "这次对话有帮助吗？",
  "rating_overall": "助手整体体验",
  "rating_recommend": "您会推荐RisTA吗？",
  "rating_yes": "是",
  "rating_no": "否",
  "rating_submit": "提交评价",
  "rating_skip": "跳过",
  "rating_thanks": "感谢您的反馈！",
  "generating_estimate": "正在生成成本估算...",
  "profile_info": "个人资料",
  "profile_name": "姓名",
  "profile_email": "邮箱",
  "profile_role": "角色",
  "profile_member_since": "注册时间",
  "profile_rerun_onboarding": "重新运行引导",
  "profile_language_pref": "首选语言",
  "profile_language_saved": "语言偏好已保存！",
  "privacy_heading": "隐私政策",
  "terms_heading": "条款和条件",
  "about_heading": "关于 Infinity Business",
  "walkthrough_heading": "使用指南",
  "services_cta_title": "准备开始了吗？",
  "services_talk_rista": "与RisTA对话",
  "nav_tools": "工具",
  "nav_marketplace": "市场",
  "chat_digital_partner": "数字合作伙伴",
  "chat_online": "在线",
  "chat_help_text": "我可以帮助网站开发、移动应用、设计、加密货币等。",
  "chat_your_partner": "您的数字合作伙伴",
  "chat_assistant_subtitle": "与您的智能助手聊天",
  "tab_password": "密码",
  "tab_rista_services": "RisTA服务",
  "tab_analytics": "分析",
  "tab_projects": "项目",
  "tab_referral": "推荐计划",
  "marketplace_title": "模板市场",
  "marketplace_subtitle": "可自定义的高级模板。专业品质，即用即得。",
  "marketplace_search": "搜索模板...",
  "marketplace_purchase": "购买",
  "marketplace_preview": "预览",
  "marketplace_all": "全部",
  "marketplace_category_website": "网站",
  "marketplace_category_brand": "品牌",
  "marketplace_category_resume": "简历",
  "marketplace_downloads": "下载",
  "marketplace_features": "功能",
  "case_studies_title": "客户成功案例",
  "case_studies_subtitle": "来自真实企业的真实结果。查看转型成效。",
  "case_studies_before": "之前",
  "case_studies_after": "之后",
  "case_studies_cta_title": "准备好发展您的业务了吗？",
  "case_studies_cta_desc": "加入这些企业，通过我们的智能服务获得类似的成果。",
  "case_studies_cta_btn": "开始",
  "profile_go_homepage": "前往首页",
  "onboarding_welcome_title": "欢迎来到Infinity Business",
  "onboarding_welcome_subtitle": "您的智能数字合作伙伴",
  "onboarding_welcome_content": "Infinity Business提供全面的B2B和P2P数字服务。我们的智能助手RisTA将为您提供指导。",
  "onboarding_welcome_item1": "智能项目估算",
  "onboarding_welcome_item2": "网站、移动和设计服务",
  "onboarding_welcome_item3": "加密货币教育和投资工具",
  "onboarding_welcome_item4": "个性化咨询",
  "onboarding_next": "下一步",
  "onboarding_get_started": "开始",
  "onboarding_back": "返回",
  "onboarding_biz_title": "服务选择",
  "onboarding_biz_subtitle": "什么最能描述您的需求？",
  "onboarding_biz_content": "帮助我们为您推荐合适的服务：",
  "onboarding_biz_type_startup": "创业公司 / 新业务",
  "onboarding_biz_type_smb": "中小企业",
  "onboarding_biz_type_enterprise": "大型企业 / 集团",
  "onboarding_biz_type_freelancer": "自由职业者 / 个人",
  "onboarding_biz_type_investor": "投资者 / 加密货币爱好者",
  "change_password_title": "修改密码",
  "referral_title": "推荐计划",
  "referral_generate": "生成我的推荐码",
  "referral_redeem_title": "兑换码",
  "referral_redeem_btn": "兑换",
  "referral_referrals": "推荐",
  "referral_rewards": "奖励",
  "referral_copy_link": "复制链接",
  "referral_copied": "已复制！",
  "project_tracker_title": "项目跟踪",
  "analytics_total_services": "总服务",
  "analytics_completed": "已完成",
  "analytics_pending": "待处理",
  "analytics_total_spent": "总支出",
  "analytics_credit_balance": "信用余额",
  "analytics_recent": "最近服务",
  "nav_try_free": "免费试用",
  "testimonial_1_text": "RisTA帮助我们在短短2周内建立了整个网络形象。智能咨询对我们的需求理解得非常准确。",
  "testimonial_2_text": "品牌套件和社交媒体日历为我们节省了数月的工作。质量超越了传统代理机构。",
  "testimonial_3_text": "我经常使用简历生成器和竞争分析工具。智能输出可直接投入使用，信用系统使价格透明。",
  "services_cta_desc": "与RisTA交谈，我们的智能数字助手，获取个性化的项目报价。",
  "services_free_audit": "免费SEO审计",
  "tools_title": "免费营销工具",
  "tools_subtitle": "试用我们的免费工具 - 无需注册",
  "sp_basic_web_name": "基础网站建设",
  "sp_basic_web_desc": "为您的企业打造具有现代设计和完整移动兼容性的专业网站。",
  "sp_basic_web_feat": "现代响应式设计|最多5个页面|联系表单集成|移动端优化|基础SEO设置|内容输入协助",
  "sp_web_store_name": "网上商店 / 电子商务",
  "sp_web_store_desc": "功能齐全的电子商务平台，集成支付和营销工具。",
  "sp_web_store_feat": "完整的在线商店|支付处理|产品管理|订单跟踪|SEO优化|营销策略包含",
  "sp_custom_web_name": "定制Web应用",
  "sp_custom_web_desc": "根据您的确切业务需求量身定制的Web应用。",
  "sp_custom_web_feat": "定制软件设计|API集成|数据库架构|可扩展基础设施|管理面板|持续支持",
  "sp_mobile_app_name": "移动应用",
  "sp_mobile_app_desc": "适用于iOS和Android的原生和跨平台移动应用。",
  "sp_mobile_app_feat": "iOS和Android|跨平台开发|推送通知|应用商店提交|UI/UX设计|后端集成",
  "sp_seo_name": "SEO和数字营销",
  "sp_seo_desc": "通过全面的SEO和数字营销策略提升您的在线可见度。",
  "sp_seo_feat": "完整SEO审计|关键词优化|内容策略|Google Ads管理|社交媒体营销|月度报告",
  "sp_graphic_name": "平面设计和品牌塑造",
  "sp_graphic_desc": "为您的企业形象提供完整的品牌和平面设计解决方案。",
  "sp_graphic_feat": "标志设计|品牌标识|营销材料|社交媒体图形|印刷设计|风格指南",
  "sp_crypto_edu_name": "加密货币教育课程",
  "sp_crypto_edu_desc": "向行业专家学习加密货币交易和区块链技术。",
  "sp_crypto_edu_feat": "区块链基础|交易策略|钱包安全|DeFi入门|市场分析|个人指导",
  "sp_invest_name": "智能投资工具",
  "sp_invest_desc": "由智能系统驱动的专业投资跟踪和分析工具。",
  "sp_invest_feat": "投资组合跟踪|市场仪表板|智能洞察|风险评估|实时提醒|多交易所支持",
  "sp_ad_name": "广告服务",
  "sp_ad_desc": "通过我们在多个地区的广泛门户网络触达数百万人。",
  "sp_ad_feat": "20+门户网络|1000万+覆盖|定向广告|效果追踪|多平台广告|ROI优化",
  "contact_heading": "联系我们",
  "contact_subtitle_text": "有问题或想讨论项目？我们很乐意听取您的意见。",
  "contact_name_label": "姓名",
  "contact_email_label": "邮箱",
  "contact_subject_label": "主题",
  "contact_message_label": "消息",
  "contact_name_ph": "您的姓名",
  "contact_email_ph": "you@example.com",
  "contact_subject_ph": "关于什么？",
  "contact_message_ph": "告诉我们您的项目或问题...",
  "contact_send_btn": "发送消息",
  "contact_sending": "发送中...",
  "contact_sent_title": "消息已发送！",
  "contact_sent_msg": "感谢您的联系。我们将在24小时内回复。",
  "contact_send_another": "发送另一条消息",
  "contact_info_email": "邮箱",
  "contact_info_location": "位置",
  "contact_info_eu": "欧盟",
  "contact_info_response": "响应时间",
  "contact_info_response_time": "24小时内",
  "contact_info_hours": "周一至周五，9:00 - 18:00 CET",
  "tf_seo_name": "免费SEO审计",
  "tf_seo_desc": "获取任何网站的全面SEO分析 - 无需注册。",
  "tf_color_name": "调色板生成器",
  "tf_color_desc": "为您的品牌生成美丽和谐的调色板。",
  "tf_headline_name": "标题分析器",
  "tf_headline_desc": "评估标题的点击潜力和情感影响。",
  "tf_chat_name": "与RisTA聊天",
  "tf_chat_desc": "获取即时项目估算，以11种语言探索服务。",
  "tf_free_label": "免费",
  "tools_seo_title": "快速SEO检查",
  "tools_seo_desc": "任何网站的即时SEO评分",
  "tools_seo_ph": "输入网站URL（例如 example.com）",
  "tools_analyze": "分析",
  "tools_color_title": "调色板生成器",
  "tools_color_desc": "生成互补调色板",
  "tools_headline_title": "标题分析器",
  "tools_headline_desc": "分析标题效果",
  "tools_headline_ph": "输入您的标题...",
  "tools_headline_btn": "分析标题",
  "tools_issues": "发现的问题",
  "tools_suggestions": "建议",
  "tools_score": "评分",
  "docs_heading": "平台功能",
  "docs_subtitle": "Infinity Business为您的数字之旅提供的一切。",
  "docs_no_data": "暂无文档。",
  "tester_heading": "成为测试员",
  "tester_subtitle": "帮助我们改进平台，获得免费使用服务的机会。",
  "tester_req_title": "要求",
  "tester_benefit_title": "您将获得",
  "tester_apply_title": "申请加入",
  "tester_submit_app": "提交申请",
  "tester_applied_title": "申请已提交",
  "tester_applied_msg": "我们的管理员将审核您的申请并通知您。",
  "tester_need_account": "您需要一个账户才能申请。",
  "tester_dash_title": "测试员仪表板",
  "tester_weekly_logins": "每周登录",
  "tester_weekly_reports": "每周报告",
  "tester_target_met": "目标达成！",
  "tester_total_reports": "已提交报告总数",
  "tester_on_track": "进展良好",
  "tester_at_risk": "有风险",
  "tester_report_heading": "提交错误/反馈报告",
  "tester_submit_report": "提交报告",
  "seo_page_title": "免费SEO审计",
  "seo_page_btn": "运行审计",
  "seo_page_running": "分析中...",
  "referral_reward_title": "奖励机制",
  "referral_reward_desc": "您推荐的用户每次购买，您自动获得10%的免费积分。",
  "referral_reward_1": "与朋友分享您的专属推荐链接",
  "referral_reward_2": "他们购买时，您获得10%的免费积分",
  "referral_reward_3": "积分自动添加到您的余额",
  "referral_earned_label": "已赚取积分",
  "profile_picture": "头像",
  "profile_bio": "个人简介",
  "profile_website": "网站",
  "profile_interests": "兴趣",
  "profile_upload_photo": "上传照片",
  "profile_save": "保存资料",
  "admin_notes": "管理员备注",
  "admin_notes_add": "添加备注",
  "sub_most_popular": "最受欢迎",
  "sub_free": "免费",
  "sub_one_time": "一次性付款",
  "sub_team_members": "团队成员",
  "sub_members_info": "邀请团队成员共享您的计划。每个成员都有自己的登录和访问权限。",
  "sub_show_less": "显示更少",
  "sub_more_features": "更多功能",
  "sub_pay_with": "用...支付",
  "sub_preferred": "首选",
  "sub_live_crypto": "实时加密货币价格 (EUR & USD)",
  "sp_logo_name": "标志设计",
  "sp_logo_desc": "专业定制标志设计，捕捉您品牌的精髓。",
  "sp_logo_feat": "3个独特概念|无限修改|矢量文件|全彩+黑白|品牌指南|社交媒体套件",
  "sp_brand_name": "完整品牌标识",
  "sp_brand_desc": "包含标志、调色板、字体和品牌指南的完整品牌标识套餐。",
  "sp_brand_feat": "标志设计|调色板|字体选择|名片设计|信纸|品牌指南PDF|社交模板",
  "sp_poster_name": "海报设计",
  "sp_poster_desc": "引人注目的活动和广告海报设计。",
  "sp_poster_feat": "定制插图|印刷就绪文件|多种尺寸|2轮修改|高分辨率|数字+印刷",
  "sp_flyer_name": "传单设计",
  "sp_flyer_desc": "专业的营销和活动传单设计。",
  "sp_flyer_feat": "正面和背面|印刷就绪PDF|数字版|二维码|2次修改|多种格式",
  "sp_menu_name": "菜单设计",
  "sp_menu_desc": "精美的餐厅和咖啡馆菜单设计。",
  "sp_menu_feat": "定制布局|照片整合|二维码版|印刷文件|季节更新|多页",
  "currency_label": "货币",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "我们是一家专注于智能数字解决方案的科技公司。Infinity Business 成立于2026年，将智能创新与成熟专业知识相结合。",
  "about_values": "我们的价值观",
  "about_what_we_do": "我们做什么",
  "about_meet_rista": "认识 RisTA",
  "about_rista_desc": "RisTA 是我们的智能助手。帮助确认项目需求，提供即时指导，并将您与我们的团队联系起来。全天候可用，多语言支持。",
  "about_talk_rista": "与 RisTA 对话",
  "about_val_trust": "信任与安全",
  "about_val_trust_desc": "我们采用最高标准的数据保护措施。",
  "about_val_innovation": "创新",
  "about_val_innovation_desc": "尖端智能技术驱动我们的解决方案。",
  "about_val_partnership": "合作伙伴",
  "about_val_partnership_desc": "我们作为真正的合作伙伴与您并肩工作。",
  "about_val_global": "全球覆盖",
  "about_val_global_desc": "我们的解决方案专为国际市场设计。",
  "about_svc_web": "网站开发",
  "about_svc_web_desc": "全栈Web应用、电商平台和CMS解决方案。",
  "about_svc_mobile": "移动应用",
  "about_svc_mobile_desc": "iOS和Android原生及跨平台应用。",
  "about_svc_software": "定制软件",
  "about_svc_software_desc": "量身定制的软件解决方案，自动化业务流程。",
  "about_svc_invest": "智能投资",
  "about_svc_invest_desc": "智能驱动的加密货币和DeFi工具及专业交易服务。",
  "micro_tools_title": "智能微工具",
  "micro_tools_subtitle": "基于智能系统的即时洞察，用于潜在客户生成和战略规划。",
  "micro_tools_all": "全部",
  "micro_tools_try": "试试",
  "micro_tools_generate_free": "生成 (免费)",
  "micro_tools_generate_paid": "生成",
  "micro_tools_close": "关闭",
  "micro_tools_interested": "感兴趣？",
  "tools_view_service": "查看服务",
  "tools_talk_rista": "与 RisTA 对话",
  "competitor_title": "智能竞争分析",
  "competitor_desc": "输入竞争对手URL获取智能分析报告。",
  "competitor_url_ph": "输入竞争对手URL",
  "competitor_analyze": "分析竞争对手",
  "competitor_score": "总体得分",
  "competitor_seo": "SEO 分析",
  "competitor_design": "设计分析",
  "competitor_content": "内容分析",
  "competitor_strengths": "优势",
  "competitor_weaknesses": "劣势",
  "competitor_opportunities": "机会",
  "competitor_recommendations": "建议",
  "accessibility_title": "无障碍检查",
  "accessibility_desc": "检查网站无障碍标准合规性",
  "cat_lead_gen": "获客与流量",
  "cat_discovery": "报告发现",
  "cat_email": "邮件与工作流",
  "cat_planning": "规划与战略",
  "cat_content": "内容与定位",
  "sp_tools_title": "智能微服务",
  "sp_tools_desc": "即时智能服务，包括内容创建、品牌建设、分析和专业文档。",
  "sp_free_title": "免费工具",
  "sp_free_desc": "使用这些免费工具试用我们的平台。",
  "a11y_checker": "无障碍检查器",
  "a11y_rescan": "重新扫描",
  "a11y_scanning": "正在运行WCAG审计...",
  "a11y_compliant": "合规",
  "a11y_passed": "通过",
  "a11y_violations": "违规",
  "a11y_incomplete": "需要审查",
  "a11y_issues_found": "发现问题",
  "a11y_no_issues": "未发现无障碍问题！",
  "a11y_disclaimer": "自动检查覆盖约30%的问题。建议使用屏幕阅读器进行手动测试。",
  "a11y_error": "审计失败。请重试。",
  "admin_ratings": "评分和反馈",
  "admin_timeline": "项目时间线",
  "admin_add_milestone": "添加里程碑",
  "admin_milestone_title": "里程碑标题",
  "admin_milestone_desc": "描述（可选）",
  "admin_no_milestones": "暂无里程碑。添加第一个吧！",
  "admin_email_templates_desc": "使用可视化块编辑器自定义邮件模板。",
  "admin_preloader": "预加载器配置",
  "admin_image_gen": "图像生成",
  "admin_health_score": "健康评分",
  "nav_health_score": "健康评分",
  "admin_new": "新",
  "admin_score": "评分",
  "admin_avg_rating": "平均评分",
  "admin_avg_exp": "平均体验",
  "admin_reviews": "评论",
  "admin_out_of": "满分",
  "admin_total": "总计",
  "admin_unread": "未读",
  "admin_active": "活跃",
  "admin_pending": "待处理",
  "admin_save": "保存",
  "admin_cancel": "取消",
  "admin_delete": "删除",
  "admin_edit": "编辑",
  "admin_status": "状态",
  "admin_actions": "操作",
  "admin_created": "创建时间",
  "admin_updated": "更新时间",
  "admin_view_all": "查看全部",
  "admin_no_data": "暂无数据",
  "status_planned": "已计划",
  "status_in_progress": "进行中",
  "status_completed": "已完成",
  "status_blocked": "已阻止",
  "priority_low": "低",
  "priority_medium": "中",
  "priority_high": "高",
  "priority_critical": "紧急",
  "analytics_subscription": "订阅",
  "developer_title": "开发者API",
  "developer_subtitle": "将我们的智能服务集成到您的应用中",
  "estimate_accept": "接受并提交",
  "estimate_revise": "修改",
  "estimate_title": "项目费用估算",
  "estimate_service": "服务",
  "estimate_complexity": "复杂度",
  "estimate_base_price": "基础价格",
  "estimate_cost": "估算费用",
  "estimate_features": "核心功能",
  "hosting_title": "托管套餐",
  "hosting_subtitle": "为您的业务提供可靠、快速的托管服务",
  "sp_health_score": "网站健康评分",
  "sp_health_score_desc": "全面的网站分析，涵盖SEO、性能、安全性和可访问性。",
  "sp_health_score_name": "网站健康评分",
  "sp_health_score_feat": "SEO分析|性能检查|安全扫描|无障碍审计|详细报告|改进建议",
  "sp_hosting_name": "托管网站托管",
  "sp_hosting_desc": "为您的网站和应用提供安全、快速、可靠的托管基础设施。",
  "sp_hosting_feat": "99.9%可用性|SSL证书|每日备份|CDN集成|24/7监控|自动扩展",
  "sp_biz_plan_name": "智能商业计划",
  "sp_biz_plan_desc": "生成包含财务、市场分析和增长策略的全面商业计划。",
  "sp_biz_plan_feat": "执行摘要|市场分析|财务预测|竞争概览|增长策略|投资者格式",
  "sp_seo_report_name": "网站审计报告",
  "sp_seo_report_desc": "自动化站点分析，提供可操作的SEO建议和性能洞察。",
  "sp_seo_report_feat": "100+检查点|性能指标|SEO建议|移动分析|安全审查|行动计划",
  "sp_email_campaign_name": "邮件营销设置",
  "sp_email_campaign_desc": "专业的邮件营销活动设置，包含文案、序列和受众定向。",
  "sp_email_campaign_feat": "邮件文案|序列设置|受众定向|A/B测试|分析设置|模板设计",
  "sp_competitor_name": "竞争对手分析",
  "sp_competitor_desc": "深度竞争情报，包含SEO对比、设计审查和内容差距分析。",
  "sp_competitor_feat": "SEO对比|设计审查|内容差距|市场定位|SWOT分析|战略建议",
  "sp_legal_docs_name": "法律文件生成器",
  "sp_legal_docs_desc": "专业法律模板，包括保密协议、合同和服务条款。",
  "sp_legal_docs_feat": "保密协议模板|服务合同|服务条款|隐私政策|GDPR合规|自定义条款",
  "sp_resume_name": "智能简历生成器",
  "sp_resume_desc": "创建针对目标职位和行业优化的ATS简历。",
  "sp_resume_feat": "ATS优化|行业模板|关键词匹配|求职信|LinkedIn优化|PDF导出",
  "sp_brand_kit_name": "智能Logo和品牌套件",
  "sp_brand_kit_desc": "完整的品牌标识套件，包含Logo概念、调色板和社交媒体素材。",
  "sp_brand_kit_feat": "Logo概念|调色板|字体排版|社交媒体素材|品牌指南|图标集",
  "sp_social_cal_name": "社交媒体日历",
  "sp_social_cal_desc": "30天智能生成的社交媒体帖子，附带互动策略。",
  "sp_social_cal_feat": "30天日历|帖子文案|话题标签策略|互动技巧|最佳发布时间|平台优化",
  "sp_translation_name": "智能翻译",
  "sp_translation_desc": "50+语言的专业文档翻译，附带文化适配。",
  "sp_translation_feat": "50+语言|文化适配|技术术语|快速交付|校对|格式保留",
  "sp_video_script_name": "智能视频脚本编写",
  "sp_video_script_desc": "为YouTube、TikTok和广告创建引人入胜的视频脚本，优化最大互动。",
  "sp_video_script_feat": "YouTube脚本|TikTok内容|广告文案|开场优化|CTA位置|互动技巧",
  "sp_free_seo_name": "免费SEO审计",
  "sp_free_seo_desc": "对任何网站运行免费的全面SEO审计，发现优化机会。",
  "sp_free_seo_feat": "即时结果|100+检查|性能评分|移动检查|安全扫描|免费报告",
  "sp_free_tools_name": "免费数字工具",
  "sp_free_tools_desc": "访问我们的免费工具集，包括调色板、标题分析器等。",
  "sp_free_tools_feat": "调色板生成器|标题分析器|密码生成器|二维码生成器|单位换算器|无需注册",
  "admin_chat_analytics": "聊天分析",
  "admin_ab_testing": "A/B测试",
  "admin_ui_toggles": "UI开关",
  "admin_audit_trail": "审计日志",
  "admin_adv_reports": "高级报告",
  "admin_rate_limiting": "速率限制",
  "admin_email_builder": "邮件构建器",
  "admin_rbac": "访问控制",
  "admin_social_auto": "社交媒体自动化",
  "admin_health_monitor": "健康监控",
  "profile_country": "国家",
  "profile_country_ph": "例如：中国、德国、美国",
  "health_title": "网站健康评分",
  "health_desc": "一个仪表板全面分析您网站的SEO、性能、安全性和可访问性。",
  "health_premium_badge": "高级功能",
  "health_url_ph": "输入网站URL（例如 example.com）",
  "health_scan_btn": "扫描",
  "health_scanning": "扫描中...",
  "health_scan_error": "网站扫描失败。请检查URL。",
  "health_overall": "总体健康评分",
  "health_response": "响应",
  "health_size": "大小",
  "health_seo": "SEO",
  "health_perf": "性能",
  "health_security": "安全",
  "health_a11y": "无障碍",
  "health_history": "扫描历史",
  "health_login_required": "登录以使用健康评分",
  "health_login_desc": "创建免费账户以扫描网站并跟踪改进。",
  "health_upsell_title": "需要定期监控？",
  "health_upsell_desc": "升级到高级版，获取自动每周扫描、邮件提醒和趋势跟踪。",
  "health_upgrade_btn": "升级到高级版",
  "seo_cta_title": "需要帮助修复这些问题？",
  "seo_cta_desc": "我们的智能SEO审计覆盖100+检查点。获取专业帮助优化您的网站。",
  "walkthrough_gmail": "Gmail智能助手",
  "walkthrough_gmail_desc": "了解RisTA如何整理您的收件箱",
  "walkthrough_calendar": "个人顾问",
  "walkthrough_calendar_desc": "通过聊天管理日历、待办和邮件",
  "walkthrough_ai": "智能系统服务",
  "walkthrough_ai_desc": "简历、商业计划、品牌套件等",
  "submit_service_request": "提交您的服务请求",
  "profile_admin_dashboard": "打开管理员面板",
  "profile_appearance": "外观和无障碍",
  "profile_theme": "主题",
  "profile_text_size": "文字大小",
  "profile_text_size_hint": "调整文字大小以便于阅读。",
  "try_free_title": "免费工具和试用服务",
  "try_free_subtitle": "无需信用卡。立即开始使用我们的工具。",
  "try_free_section": "完全免费 — 无需账户",
  "try_free_trial_section": "智能系统服务 — 使用积分体验",
  "try_free_trial_desc": "注册获取积分，使用这些智能服务。",
  "try_free_cta": "准备开始了吗？",
  "try_free_cta_desc": "创建免费账户，获取首批积分并解锁所有智能服务。",
  "try_free_cta_btn": "免费注册",
  "review_title": "客户评价",
  "review_subtitle": "来自我们帮助过的企业的真实反馈",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_2_role": "市场总监, BioFresh",
  "testimonial_3_role": "自由开发者",
  "admin_overview": "概览",
  "admin_my_account": "我的账户",
  "admin_health": "健康监控",
  "admin_analytics": "分析",
  "admin_integrations": "集成",
  "admin_requests": "服务请求",
  "admin_high_value": "高价值线索",
  "admin_followups": "跟进邮件",
  "admin_users": "用户管理",
  "admin_crypto_payments": "加密支付",
  "admin_bug_reports": "错误报告",
  "admin_pricing": "动态定价",
  "admin_defi": "DeFi项目",
  "admin_chat_sessions": "聊天会话",
  "admin_language_requests": "语言请求",
  "admin_notifications": "通知",
  "admin_sendgrid": "邮件(SendGrid)",
  "admin_ai_config": "模型配置",
  "admin_live_analytics": "实时分析",
  "admin_system_config": "系统配置",
  "admin_backup": "备份与恢复",
  "admin_referrals": "推荐计划",
  "admin_invoices": "开票",
  "admin_billing": "周期性计费",
  "admin_blog": "博客管理",
  "admin_logo": "Logo和网站图标",
  "admin_promo": "促销代码",
  "admin_currency": "多币种",
  "admin_domain": "域名管理",
  "admin_cdn": "CDN管理",
  "admin_social": "社交媒体",
  "admin_avatar_selector": "头像选择器",
  "admin_avatar_builder": "头像构建器",
  "admin_client_portal": "客户门户",
  "admin_abandoned_carts": "废弃购物车",
  "rista_login_required": "需要登录",
  "rista_login_desc": "登录或创建帐户，与RisTA聊天并获取个性化的商业建议。",
  "rista_login_btn": "登录",
  "rista_signup_btn": "注册",
  "admin_high_leads": "优先线索",
  "admin_surveys": "满意度调查",
  "admin_rista": "RisTA服务",
  "admin_docs": "文档",
  "admin_audit": "平台审计",
  "admin_kb": "知识库",
  "admin_reports": "管理员报告",
  "admin_ad_gen": "广告生成器",
  "admin_service_mgr": "服务管理",
  "admin_tester": "测试员计划",
  "admin_credits": "积分配置",
  "admin_account_mgmt": "账户管理",
  "admin_payment_opts": "支付选项",
  "admin_lead_tracking": "线索跟踪",
  "admin_demo": "演示访问",
  "admin_crypto_trading": "加密交易",
  "admin_auto_posting": "智能自动发布",
  "admin_fb": "FB分析",
  "admin_referral_board": "推荐排行榜",
  "admin_escalations": "聊天升级",
  "admin_portfolio": "作品集管理",
  "admin_email_templates": "邮件模板",
  "admin_social_icons": "社交图标",
  "admin_ai_prompts": "智能提示词",
  "admin_panel": "管理面板",
  "admin_sign_out": "退出",
  "admin_search_tabs": "搜索标签...",
  "admin_demo_banner": "只读模式 - 演示查看器账户（所有用户数据已隐藏）",
  "admin_system_admin": "系统管理员",
  "admin_loading": "加载中...",
  "admin_no_matching": "无匹配标签",
  "tester_req_1": "每周至少登录5次",
  "tester_req_2": "每周至少提交10份错误/反馈报告",
  "tester_req_3": "测试不同功能、页面和用户流程",
  "tester_benefit_1": "免费访问智能系统服务（根据请求）",
  "tester_benefit_2": "测试员仪表板，跟踪进度",
  "tester_benefit_3": "团队优先支持",
  "tester_motivation": "您为什么想成为测试员？",
  "tester_motivation_ph": "告诉我们您为什么想帮助测试平台...",
  "tester_experience": "测试经验（可选）",
  "tester_experience_ph": "任何相关经验...",
  "tester_dash_desc": "通过达成每周目标保持您的测试员身份。",
  "tester_logins_needed": "本周还需登录",
  "tester_reports_needed": "本周还需报告",
  "tester_report_title_ph": "标题（例如'按钮在手机上无法点击'）",
  "tester_report_desc_ph": "详细描述问题或建议...",
  "tester_report_page_ph": "页面URL（可选）",
  "seo_page_desc": "输入任何网站URL，获取全面的SEO分析和可操作建议。",
  "seo_page_ph": "输入网站URL（例如 example.com）",
  "seo_page_error": "网站审计失败。请检查URL并重试。",
  "profile_bio_ph": "介绍一下自己...",
  "profile_website_ph": "https://yourwebsite.com",
  "profile_interests_ph": "例如：Web开发、加密货币、科技",
  "admin_notes_ph": "添加关于此用户的备注...",
  "profile_change_avatar": "更改头像",
  "profile_about": "关于您",
  "profile_interests_hint": "用逗号分隔兴趣",
  "privacy_s1_title": "1. 我们收集的信息",
  "privacy_s2_title": "2. 我们如何使用您的信息",
  "privacy_s3_title": "3. 数据共享",
  "privacy_s4_title": "4. 数据安全",
  "privacy_s5_title": "5. 您的权利",
  "privacy_s6_title": "6. Cookie和跟踪",
  "privacy_s7_title": "7. 数据保留",
  "privacy_s8_title": "8. 国际传输",
  "privacy_s9_title": "9. 本政策的变更",
  "privacy_s10_title": "10. 联系我们",
  "privacy_intro": "Infinity Business（\"我们\"），由Liber Nostra d.o.o.运营，致力于保护您的隐私。",
  "privacy_last_updated": "最后更新：2026年3月7日",
  "terms_s1_title": "1. 简介",
  "terms_s2_title": "2. 服务",
  "terms_s3_title": "3. 用户账户",
  "terms_s4_title": "4. 付款和账单",
  "terms_s5_title": "5. 智能服务免责声明",
  "terms_s6_title": "6. 知识产权",
  "terms_s7_title": "7. 隐私和数据",
  "terms_s8_title": "8. 加密货币免责声明",
  "terms_s9_title": "9. 责任限制",
  "terms_s10_title": "10. 修改",
  "terms_s11_title": "11. 适用法律",
  "terms_s12_title": "12. 联系方式",
  "terms_last_updated": "最后更新：2026年2月",
  "referral_subtitle": "邀请朋友赢取奖励",
  "marketplace_close_preview": "关闭预览",
  "marketplace_live_preview": "实时预览",
  "billing_management": "账单管理",
  "billing_manage_desc": "通过Stripe门户管理您的付款方式、查看发票或更新账单信息。",
  "billing_manage_btn": "管理账单",
  "billing_cancel_btn": "取消方案",
  "change_password_current": "当前密码",
  "change_password_new": "新密码",
  "change_password_confirm": "确认新密码",
  "change_password_btn": "修改密码",
  "change_password_social": "社交登录账户无法更改密码。",
  "nav_currency": "货币",
  "nav_orders": "我的订单",
  "plan_features": "您的套餐功能",
  "project_no_projects": "暂无项目。购买服务后，项目将显示在这里。",
  "onboarding_services_title": "探索我们的服务",
  "onboarding_services_subtitle": "为您量身定制的两个类别",
  "onboarding_services_content": "我们提供两类服务：",
  "onboarding_services_item1": "B2B：网页开发、移动应用、平面设计、托管、定制软件、广告、API访问",
  "onboarding_services_item2": "P2P：加密教育、DeFi解决方案、域名市场、托管交易、数字工具",
  "onboarding_services_item3": "智能微工具：市场快照、竞争对手分析、邮件生成器、博客大纲、TAM计算器等",
  "onboarding_services_item4": "随时与RisTA对话获取个性化报价和服务推荐",
  "onboarding_credits_title": "积分系统",
  "onboarding_credits_subtitle": "智能服务预付余额",
  "onboarding_credits_content": "使用积分即时访问我们的智能服务：",
  "onboarding_credits_item1": "1 EUR = 1积分。基础：29积分，高级：79，终身：499",
  "onboarding_credits_item2": "免费工具无需积分。付费微工具每个$1",
  "onboarding_credits_item3": "批量折扣：50+ EUR享5%，100+享10%，250+享15%，500+享20%",
  "onboarding_credits_item4": "通过银行卡、PayPal、myPOS或加密货币在积分面板充值",
  "onboarding_chat_title": "与RisTA对话",
  "onboarding_chat_subtitle": "您的数字伙伴已准备就绪",
  "onboarding_chat_content": "RisTA可以帮助您：",
  "onboarding_chat_item1": "获取项目估价和报价",
  "onboarding_chat_item2": "详细了解服务选项",
  "onboarding_chat_item3": "提交服务请求",
  "onboarding_chat_item4": "用11种语言回答问题",
  "support_tickets": "支持工单",
  "admin_support_tickets": "支持工单",
  "admin_auto_translate": "自动翻译",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "AI潜客挖掘",
  "admin_project_mgmt": "项目管理",
  "admin_analytics_widget": "分析小部件",
  "admin_doc_mgmt": "文档管理",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "白标",
  "admin_multi_tenant": "多租户",
  "popular_services": "热门服务",
  "popular_services_desc": "客户最常请求的服务",
  "purchases": "购买记录",
  "admin_funnel": "转化漏斗",
  "admin_wl_licensing": "SaaS许可证",
  "admin_analytics_export": "分析导出",
  "service_detail_features": "包含内容",
  "service_detail_related": "相关服务",
  "service_detail_back": "所有服务",
  "checkout_currency": "结账货币",
  "upsell_title": "完善您的设置",
  "upsell_desc": "购买类似产品的客户还添加了：",
  "cart_checkout": "结账",
  "cart_empty": "您的购物车是空的",
  "push_notifications": "推送通知",
  "push_enabled": "通知已启用",
  "push_disabled": "启用通知",
  "blog_ai_generate": "AI生成",
  "blog_gen_service": "为服务生成",
  "blog_generating": "生成中...",
  "export_revenue": "收入报告",
  "export_funnel": "转化漏斗",
  "export_users": "用户列表",
  "export_pdf": "执行摘要",
  "license_generate": "生成许可证",
  "license_revoke": "撤销",
  "license_renew": "续期",
  "license_validate": "验证",
  "tier_starter": "入门版",
  "tier_professional": "专业版",
  "tier_enterprise": "企业版",
  "blog_subtitle": "来自 Infinity Business 的见解、更新和指南。",
  "blog_search_placeholder": "搜索文章...",
  "blog_all": "全部",
  "blog_no_posts": "未找到文章。请稍后再来！",
  "blog_prev": "上一页",
  "blog_next": "下一页",
  "blog_back": "返回博客",
  "micro_tools": "智能微工具",
  "micro_tools_title": "智能微工具",
  "micro_tools_subtitle": "免费AI驱动的商业微工具",
  "color_palette_title": "调色板生成器",
  "color_palette_desc": "为您的品牌生成精美的调色板",
  "color_palette_generate": "生成调色板",
  "color_palette_copy": "复制",
  "color_palette_copied": "已复制！",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "互补色",
  "color_palette_analogous": "类似色",
  "color_palette_triadic": "三元色",
  "color_palette_monochromatic": "单色",
  "admin_menu_overview": "概览",
  "admin_menu_users": "用户",
  "admin_menu_blog": "博客管理",
  "admin_menu_analytics": "分析",
  "admin_menu_settings": "设置",
  "admin_menu_services": "服务",
  "admin_menu_chat": "聊天会话",
  "admin_menu_notifications": "通知",
  "admin_menu_support": "支持",
  "admin_menu_security": "安全",
  "admin_menu_backup": "备份",
  "admin_menu_revenue": "收入",
  "admin_menu_funnel": "漏斗",
  "admin_menu_invoicing": "开票",
  "admin_menu_projects": "项目",
  "admin_menu_email": "邮件编辑器",
  "admin_menu_ai_config": "AI配置",
  "admin_menu_live_analytics": "实时分析",
  "admin_menu_platform_audit": "平台审计",
  "docs_title": "文档",
  "docs_subtitle": "了解如何使用我们的平台",
  "try_free_title": "免费试用",
  "try_free_subtitle": "免费体验我们的服务",
  "subscription_title": "订阅计划",
  "subscription_subtitle": "选择适合您的计划",
  "portfolio_title": "作品集",
  "portfolio_subtitle": "我们的作品说明一切",
  "svc_web-dev_label": "网站开发",
  "svc_web-dev_desc": "定制网站、登陆页面和网络应用",
  "svc_mobile-app_label": "移动应用开发",
  "svc_mobile-app_desc": "iOS和Android应用，跨平台解决方案",
  "svc_graphic-design_label": "平面设计",
  "svc_graphic-design_desc": "标志、品牌、营销材料",
  "svc_custom-software_label": "定制软件",
  "svc_custom-software_desc": "定制业务自动化和企业工具",
  "svc_ai-business-plan_label": "智能商业计划生成器",
  "svc_ai-business-plan_desc": "包含财务和市场分析的完整商业计划",
  "svc_ai-seo-report_label": "网站审计和SEO报告",
  "svc_ai-seo-report_desc": "自动化网站分析及行动建议",
  "svc_ai-email-campaign_label": "邮件营销设置",
  "svc_ai-email-campaign_desc": "AI撰写文案并设置邮件序列",
  "svc_ai-competitor-analysis_label": "竞争分析报告",
  "svc_ai-competitor-analysis_desc": "市场情报和竞争定位",
  "svc_ai-legal-docs_label": "法律文件生成器",
  "svc_ai-legal-docs_desc": "NDA、合同、服务条款模板",
  "svc_crypto-education_label": "加密货币教育",
  "svc_crypto-education_desc": "学习区块链、DeFi和加密基础",
  "svc_investment-tools_label": "投资工具",
  "svc_investment-tools_desc": "投资组合跟踪和市场分析",
  "svc_defi-solutions_label": "DeFi解决方案",
  "svc_defi-solutions_desc": "智能合约、流动性挖矿",
  "svc_personal-advertising_label": "个人品牌",
  "svc_personal-advertising_desc": "建立您的在线形象",
  "svc_ai-resume_label": "智能简历生成器",
  "svc_ai-resume_desc": "ATS优化的简历",
  "svc_ai-brand-kit_label": "智能标志和品牌套件",
  "svc_ai-brand-kit_desc": "标志、调色板、字体和社交媒体素材",
  "svc_ai-social-calendar_label": "社交媒体日历与分析",
  "svc_ai-social-calendar_desc": "30天AI生成的帖子",
  "svc_ai-translation_label": "智能翻译服务",
  "svc_ai-translation_desc": "50+语言专业文件翻译",
  "svc_ai-video-script_label": "智能视频脚本撰写器",
  "svc_ai-video-script_desc": "YouTube、TikTok和广告脚本",
  "admin_grp_dashboard": "仪表板",
  "admin_grp_users": "用户与权限",
  "admin_grp_analytics": "分析与报告",
  "admin_grp_services": "服务与定价",
  "admin_grp_crypto": "加密与DeFi",
  "admin_grp_leads": "线索与CRM",
  "admin_grp_content": "内容",
  "admin_grp_comm": "通讯",
  "admin_grp_social": "社交媒体",
  "admin_grp_ai": "AI与自动化",
  "admin_grp_design": "设计与品牌",
  "admin_grp_system": "系统",
  "admin_grp_projects": "项目与测试",
  "color_palette_professional": "专业",
  "color_palette_playful": "活泼",
  "color_palette_luxury": "奢华",
  "color_palette_nature": "自然",
  "color_palette_tech": "科技",
  "color_palette_warm": "温暖",
  "color_palette_cool": "冷酷",
  "blog_translating": "正在翻译文章...",
  "blog_translated_cached": "已翻译",
  "blog_translated_fresh": "刚刚翻译",
  "blog_show_original": "显示原文",
  "privacy_s1_content": "我们收集您直接提供给我们的信息，包括：\n- **账户信息**：创建账户时的姓名、电子邮件和密码。\n- **服务请求**：项目详情、预算、时间表和联系方式。\n- **支付信息**：通过我们的合作伙伴（Stripe、myPOS）安全处理的账单详情。\n- **通信数据**：通过RisTA聊天的消息、联系表单和电子邮件通信。\n- **使用数据**：浏览器类型、IP地址、访问页面和交互模式。",
  "privacy_s2_content": "我们使用收集的信息来：\n- 提供、维护和改进我们的服务\n- 处理交易并发送相关信息\n- 发送技术通知、更新和支持消息\n- 回复您的评论、问题和客户服务请求\n- 监控和分析趋势、使用情况和活动\n- 检测和防止欺诈活动\n- 个性化您与RisTA的体验",
  "privacy_s3_content": "我们不出售您的个人信息。我们可能与以下方共享信息：\n- **服务提供商**：代表我们执行服务的第三方公司。\n- **法律要求**：当法律要求时。\n- **业务转让**：与合并或出售相关。\n- **同意**：经您明确同意。",
  "privacy_s4_content": "我们实施行业标准安全措施：\n- 传输中（TLS/SSL）和静态数据加密\n- 支持双因素认证（2FA）\n- 定期安全审计\n- 访问控制和认证\n- 通过PCI合规伙伴安全处理支付",
  "privacy_s5_content": "根据适用的数据保护法（包括GDPR），您有权：\n- **访问**：请求您个人数据的副本\n- **更正**：请求更正不准确的数据\n- **删除**：请求删除您的数据\n- **限制**：请求限制处理\n- **可携带性**：请求以机器可读格式传输\n- **反对**：反对数据处理\n- **撤回同意**：随时撤回同意\n\n联系我们：privacy@infinitybusiness.org。",
  "privacy_s6_content": "我们使用基本Cookie来维护您的会话和偏好。您可以通过浏览器设置控制Cookie。",
  "privacy_s7_content": "我们仅在完成收集目的所需的时间内保留您的个人数据。",
  "privacy_s8_content": "您的数据可能被转移到欧洲经济区以外的国家。我们确保适当的保障措施。",
  "privacy_s9_content": "我们可能不时更新此隐私政策。重大变更将发布在此页面上。",
  "privacy_s10_content": "如有问题，请联系：\n\n**Liber Nostra d.o.o.**\n电子邮件：privacy@infinitybusiness.org\n网站：infinitybusiness.org",
  "terms_s1_content": "欢迎使用Infinity Business（\"infinitybusiness.org\"），由**Liber Nostra d.o.o.**运营。使用我们的平台即表示您同意这些条款。",
  "terms_s2_content": "Infinity Business提供AI辅助数字服务：\n- 网站开发、移动应用和平面设计（B2B）\n- 企业和数字广告服务\n- 加密货币教育、投资工具和DeFi（P2P）\n- RisTA AI助手\n- 域名和网站托管",
  "terms_s3_content": "某些功能需要创建账户。您有责任保护您的登录凭证的机密性。",
  "terms_s4_content": "服务可能需要付费。付款通过第三方处理（Stripe、PayPal、加密货币）。退款政策：\n- **一次性服务**：交付后不可退款。\n- **订阅**：可随时取消。\n- **定制项目**：按个别协议处理。",
  "terms_s5_content": "我们的AI助手\"RisTA\"提供自动化指导。仅供参考。",
  "terms_s6_content": "本平台上的所有内容均为Liber Nostra d.o.o.的财产。",
  "terms_s7_content": "您的平台使用还受我们隐私政策的约束。",
  "terms_s8_content": "加密货币相关服务仅供参考。我们不提供财务建议。",
  "terms_s9_content": "Liber Nostra d.o.o.不对间接或后果性损害负责。",
  "terms_s10_content": "我们保留随时修改这些条款的权利。",
  "terms_s11_content": "这些条款受斯洛文尼亚共和国法律管辖。",
  "terms_s12_content": "如有疑问，请联系我们或发送邮件至support@infinitybusiness.org。",
  "admin_ad_generator": "广告生成器",
  "admin_add": "添加",
  "admin_add_prompt": "添加提示词",
  "admin_admin": "管理员",
  "admin_advanced_reporting": "高级报告",
  "admin_all": "全部",
  "admin_analytics_dashboard": "分析仪表板",
  "admin_api_key": "API Key",
  "admin_apply": "应用",
  "admin_approved": "已批准",
  "admin_archive": "归档",
  "admin_are_you_sure": "确定吗？",
  "admin_audit_alerts": "审计警报",
  "admin_author": "作者",
  "admin_avg_session": "平均会话时长",
  "admin_back": "返回",
  "admin_badge": "徽章",
  "admin_balance": "余额",
  "admin_banned": "已禁用",
  "admin_blog_manager": "博客管理器",
  "admin_body": "Body",
  "admin_bounce_rate": "跳出率",
  "admin_browser": "浏览器",
  "admin_campaign": "营销活动",
  "admin_cannot_undo": "此操作无法撤销",
  "admin_category": "分类",
  "admin_click_rate": "点击率",
  "admin_close": "关闭",
  "admin_completed": "已完成",
  "admin_configuration": "配置",
  "admin_confirm": "确认",
  "admin_contact_info": "联系信息",
  "admin_content": "内容",
  "admin_conversations": "对话",
  "admin_conversion_funnel": "转化漏斗",
  "admin_conversion_rate": "转化率",
  "admin_copied": "已复制到剪贴板",
  "admin_copy": "复制",
  "admin_count": "计数",
  "admin_country": "国家/地区",
  "admin_create": "创建",
  "admin_create_experiment": "创建实验",
  "admin_create_new": "创建新项",
  "admin_created_success": "创建成功",
  "admin_credit_config": "额度配置",
  "admin_critical": "极高",
  "admin_custom": "自定义",
  "admin_daily": "每日",
  "admin_date": "日期",
  "admin_delete_failed": "删除失败",
  "admin_deleted_success": "删除成功",
  "admin_demo_access": "演示权限",
  "admin_description": "描述",
  "admin_deselect_all": "取消全选",
  "admin_details": "详情",
  "admin_device": "设备",
  "admin_disable": "禁用",
  "admin_disabled": "已禁用",
  "admin_doc_viewer": "文档查看器",
  "admin_documentation": "文档",
  "admin_download": "下载",
  "admin_draft": "草稿",
  "admin_duplicate": "复刻",
  "admin_email": "电子邮箱",
  "admin_enable": "启用",
  "admin_enabled": "已启用",
  "admin_end_date": "结束日期",
  "admin_endpoint": "Endpoint",
  "admin_error": "错误",
  "admin_escalation_queue": "升级队列",
  "admin_event": "事件",
  "admin_events": "事件",
  "admin_experiment_name": "实验名称",
  "admin_export": "导出",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "假",
  "admin_filter": "筛选",
  "admin_frequency": "频率",
  "admin_generate": "生成",
  "admin_headers": "Headers",
  "admin_health_monitoring": "健康监测",
  "admin_high": "高",
  "admin_high_value_leads": "高价值线索",
  "admin_id": "ID",
  "admin_image": "图片",
  "admin_import": "导入",
  "admin_in_progress": "进行中",
  "admin_inactive": "未激活",
  "admin_inbox": "管理收件箱",
  "admin_speed_audit": "速度审计",
  "admin_info": "信息",
  "admin_ip_address": "IP 地址",
  "admin_joined": "加入时间",
  "admin_knowledge_base": "知识库",
  "admin_language": "语言",
  "admin_last_activity": "最后活动",
  "admin_last_login": "最后登录",
  "admin_last_triggered": "最后触发时间",
  "admin_lead_score": "线索评分",
  "admin_level": "等级",
  "admin_load_failed": "加载失败",
  "admin_loading_data": "数据加载中...",
  "admin_low": "低",
  "admin_medium": "中",
  "admin_messages": "消息",
  "admin_method": "Method",
  "admin_monetization": "变现",
  "admin_monthly": "每月",
  "admin_name": "名称",
  "admin_next": "下一步",
  "admin_no": "否",
  "admin_no_data_available": "无可用数据",
  "admin_no_experiments": "未找到实验",
  "admin_no_leads": "未找到线索",
  "admin_no_prompts": "未找到提示词",
  "admin_no_results": "无结果",
  "admin_no_results_found": "未找到结果",
  "admin_none": "无",
  "admin_off": "关闭",
  "admin_on": "开启",
  "admin_open_rate": "打开率",
  "admin_page_views": "页面浏览量",
  "admin_partner_badges": "合作伙伴徽章",
  "admin_payload": "Payload",
  "admin_payment_options": "支付选项",
  "admin_platform": "平台",
  "admin_platform_audit": "平台审计",
  "admin_points": "积分",
  "admin_portfolio_manager": "投资组合管理器",
  "admin_preloader_config": "预加载配置",
  "admin_preview": "预览",
  "admin_previous": "上一步",
  "admin_price": "价格",
  "admin_priority": "优先级",
  "admin_prompt_name": "提示词名称",
  "admin_prompt_text": "提示词正文",
  "admin_published": "已发布",
  "admin_recipients": "收件人",
  "admin_referral": "推荐",
  "admin_referral_leaderboard": "推荐排行榜",
  "admin_refresh": "刷新",
  "admin_rejected": "已拒绝",
  "admin_remove": "移除",
  "admin_reset": "重置",
  "admin_response_time": "响应时间",
  "admin_restore": "恢复",
  "admin_results": "结果",
  "admin_retry": "重试",
  "admin_revenue_dashboard": "营收仪表板",
  "admin_rista_services": "RisTA 服务",
  "admin_role": "角色",
  "admin_save_changes": "保存更改",
  "admin_save_failed": "保存失败",
  "admin_saved_success": "保存成功",
  "admin_scheduled": "已排期",
  "admin_search": "搜索",
  "admin_select": "选择",
  "admin_select_all": "全选",
  "admin_send": "发送",
  "admin_sent_success": "发送成功",
  "admin_server_resources": "服务器资源",
  "admin_service_manager": "服务管理器",
  "admin_session_duration": "会话时长",
  "admin_settings": "设置",
  "admin_slug": "Slug",
  "admin_social_automation": "社交自动化",
  "admin_something_wrong": "出错了",
  "admin_source": "来源",
  "admin_start_date": "开始日期",
  "admin_subject": "主题",
  "admin_submit": "提交",
  "admin_subscribers": "订阅者",
  "admin_success": "成功",
  "admin_suspended": "已封禁",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "标签",
  "admin_template": "模板",
  "admin_templates": "模板",
  "admin_test_results": "测试结果",
  "admin_tester_program": "测试人员计划",
  "admin_title": "标题",
  "admin_total_revenue": "总收入",
  "admin_total_sessions": "总会话数",
  "admin_total_users": "总用户数",
  "admin_trigger": "触发器",
  "admin_true": "真",
  "admin_try_again": "请重试",
  "admin_type": "类型",
  "admin_unique_visitors": "独立访客",
  "admin_unsubscribed": "已退订",
  "admin_unverified": "未验证",
  "admin_update": "更新",
  "admin_updated_success": "更新成功",
  "admin_upload": "上传",
  "admin_urgent": "紧急",
  "admin_user": "用户",
  "admin_variant_a": "变量 A",
  "admin_variant_b": "变量 B",
  "admin_verified": "已验证",
  "admin_version": "版本",
  "admin_view": "查看",
  "admin_view_details": "查看详情",
  "admin_viewer": "查看者",
  "admin_warning": "警告",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "每周",
  "admin_yes": "是",
  "admin_analytics_digest": "分析摘要",
  "admin_blog_health": "博客健康",
  "credit_title": "积分",
  "credit_subtitle": "智能服务预付余额",
  "credit_available_balance": "可用余额",
  "credit_tab_balance": "余额",
  "credit_tab_topup": "充值",
  "credit_tab_history": "历史记录",
  "credit_tab_services": "服务",
  "credit_tab_crypto": "加密货币",
  "credit_balance_desc": "您的积分可用于任何智能服务：",
  "credit_bulk_discounts": "批量优惠",
  "credit_add_credits": "添加积分",
  "credit_select_amount": "选择金额或输入自定义值：",
  "credit_bonus": "奖励",
  "credit_bonus_detail": "您将获得",
  "credit_total_word": "总计",
  "credit_method_card": "银行卡",
  "credit_method_crypto": "加密货币",
  "credit_processing": "处理中...",
  "credit_add_btn": "添加",
  "credit_no_txn": "暂无交易记录",
  "credit_txn_topup": "充值",
  "credit_txn_promo": "促销积分",
  "credit_txn_auto": "自动购买",
  "credit_txn_purchase": "购买",
  "credit_svc_intelligent": "智能服务",
  "credit_svc_available": "可用",
  "credit_svc_need_more": "还需",
  "credit_svc_more": "更多",
  "credit_crypto_send": "发送",
  "credit_crypto_amount": "金额：",
  "credit_crypto_equivalent": "等值",
  "credit_crypto_network": "网络：",
  "credit_crypto_wallet": "钱包地址",
  "credit_crypto_confirm": "我们确认交易后将添加积分。",
  "credit_payment_id": "支付ID：",
  "credit_crypto_back": "返回加密货币选择",
  "credit_crypto_select_title": "选择充值加密货币",
  "credit_crypto_choose_desc": "选择下方的币种，您将收到付款钱包地址。",
  "credit_crypto_select_btn": "选择",
  "credit_minimum": "最低€5",
  "credit_redirecting": "跳转中...",
  "credit_topup_failed": "充值失败",
  "credit_crypto_failed": "发起加密支付失败",
  "cart_title": "购物车",
  "cart_total": "总计",
  "cart_stripe_checkout": "Stripe结账",
  "cart_credits": "积分",
  "cart_secure_stripe": "安全Stripe结账",
  "cart_insufficient": "积分不足，请先充值或选择银行卡支付。",
  "cart_pay_card": "银行卡支付",
  "cart_pay_credits_btn": "积分支付",
  "cart_clear": "清空购物车",
  "cart_processing": "处理中...",
  "cart_payment_success": "支付成功！您的订单正在处理中。",
  "cart_complete_setup": "完成设置",
  "cart_also_added": "购买类似服务的客户还添加了：",
  "cart_add": "添加",
  "cart_standard": "标准",
  "cart_remaining_balance": "剩余余额：",
  "cart_checkout_failed": "结账失败",
  "cart_checkout_no_session": "无法创建结账会话",
  "cart_purchased": "已购买",
  "cart_services_with_credits": "个服务（使用积分）！",
  "credits_balance_title": "积分余额",
  "credits_topup_btn": "充值积分",
  "credits_rate": "1欧元 = 1积分",
  "credits_total_topup": "总充值金额",
  "credits_spent_credits": "已消费（积分）",
  "credits_spent_payments": "已消费（支付）",
  "credits_txn_history": "交易历史",
  "credits_no_txn": "暂无交易",
  "credits_txn_topup": "充值",
  "credits_txn_promo": "促销积分",
  "credits_txn_purchase": "服务购买",
  "credits_txn_ai": "AI服务",
  "credits_order_history": "订单历史",
  "credits_order_label": "订单：",
  "chat_translate_btn": "翻译为英语",
  "chat_translating": "翻译中...",
  "chat_translated_label": "正在显示英语翻译。点击\"显示原文\"查看原始消息。",
  "chat_show_original": "显示原文",
  "chat_show_translated": "显示翻译",
  "pkg_section_badge": "限时优惠",
  "pkg_section_title": "启动您的业务",
  "pkg_section_title_highlight": "今天",
  "pkg_section_subtitle": "专为快速上线而设计的优质套餐——从第一天起内置智能技术。",
  "pkg_section_footer": "所有价格均不包含适用的增值税。 不确定哪个套餐适合？与RisTA聊天以获取免费咨询。",
  "pkg_cta_default": "开始使用",
  "admin_package_mgr": "套餐管理器",
  "admin_pkg_title": "着陆页套餐",
  "admin_pkg_subtitle": "管理在着陆页上显示的突出定价套餐",
  "admin_pkg_seed": "生成默认值",
  "admin_pkg_new": "新套餐",
  "admin_pkg_create_title": "创建新套餐",
  "admin_pkg_edit_title": "编辑套餐",
  "admin_pkg_name": "套餐名称",
  "admin_pkg_tagline": "标语",
  "admin_pkg_description": "描述",
  "admin_pkg_price": "价格",
  "admin_pkg_currency": "货币",
  "admin_pkg_price_note": "价格备注",
  "admin_pkg_badge": "标签",
  "admin_pkg_accent": "强调色",
  "admin_pkg_cta_text": "CTA 按钮文本",
  "admin_pkg_cta_link": "CTA链接（可选）",
  "admin_pkg_sort": "排序顺序",
  "admin_pkg_features": "包含的功能/服务",
  "admin_pkg_add_feature": "添加功能",
  "admin_pkg_highlighted": "突出显示",
  "admin_pkg_normal": "正常",
  "admin_pkg_create": "创建套餐",
  "admin_pkg_save": "保存更改",
  "admin_pkg_saving": "保存中...",
  "admin_pkg_cancel": "取消",
  "admin_pkg_empty_title": "尚未配置套餐",
  "admin_pkg_empty_desc": "单击生成默认值以生成两个入门套餐，或创建您自己的套餐。",
  "admin_pkg_features_label": "功能",
  "admin_pkg_sort_label": "排序",
  "admin_pkg_delete_confirm": "删除此套餐吗？它将从着陆页中移除。",
  "admin_pkg_feature_placeholder": "功能描述...",
  "admin_pkg_pricenote_placeholder": "例如：一次性/ +5% 收入分成",
  "admin_pkg_badge_placeholder": "例如：最佳价值",
  "admin_pkg_loading": "加载套餐中...",
  "pkg_qa_have_domain": "是的，我有域名",
  "pkg_qa_need_domain": "我需要一个域名",
  "pkg_qa_describe_biz": "让我描述一下我的业务",
  "pkg_qa_more_info": "告诉我更多关于这个套餐的信息",
  "sp_addon_title": "附加服务和支持",
  "sp_addon_desc": "通过优先支持和专家咨询增强您的项目。",
  "sp_research_title": "智能研究产品",
  "sp_research_desc": "按需市场情报和智能分析工具。",
  "tier_section_badge": "智能套餐",
  "tier_section_title": "选择您的",
  "tier_section_highlight": "增长计划",
  "tier_section_subtitle": "捆绑套餐旨在提供最大价值。选择适合您阶段的层级。",
  "tier_one_time": "一次性付款",
  "tier_monthly": "按月",
  "tier_section_footer": "所有价格不含增值税。需要定制套餐？与RisTA聊天。",
  "tier_name_starter": "入门版",
  "tier_name_growth": "成长版",
  "tier_name_pro": "专业版",
  "tier_name_enterprise": "企业版",
  "tier_tag_starter": "开启数字化之旅的完美选择",
  "tier_tag_growth": "用智能工具扩展您的业务",
  "tier_tag_pro": "为认真企业提供全方位数字增长",
  "tier_tag_enterprise": "为您的企业提供完整的数字化转型",
  "tier_cta_starter": "选择入门版",
  "tier_cta_growth": "选择成长版",
  "tier_cta_pro": "选择专业版",
  "tier_cta_enterprise": "选择企业版",
  "tier_badge_popular": "热门",
  "tier_badge_best": "最佳价值",
  "tier_badge_all": "一体化",
  "tier_per_mo": "月",
  "tier_once_label": "一次性",
  "tier_or_monthly": "或",
  "tier_f_starter_1": "智能商业计划生成器",
  "tier_f_starter_2": "智能简历构建器（3份）",
  "tier_f_starter_3": "网站审计和SEO报告",
  "tier_f_starter_4": "智能标志和品牌套件",
  "tier_f_starter_5": "市场概况报告",
  "tier_f_starter_6": "FAQ回答草稿",
  "tier_f_starter_7": "趋势博客大纲",
  "tier_f_starter_8": "48小时内邮件支持",
  "tier_f_growth_1": "入门版所有内容",
  "tier_f_growth_2": "智能邮件营销活动",
  "tier_f_growth_3": "社交媒体日历与分析（3个月）",
  "tier_f_growth_4": "竞争分析报告",
  "tier_f_growth_5": "广告生成器（5个活动）",
  "tier_f_growth_6": "外联邮件生成器",
  "tier_f_growth_7": "趋势解读",
  "tier_f_growth_8": "定位分析",
  "tier_f_growth_9": "24小时内优先邮件支持",
  "tier_f_pro_1": "成长版所有内容",
  "tier_f_pro_2": "SEO和数字营销设置",
  "tier_f_pro_3": "邮件营销设置",
  "tier_f_pro_4": "智能视频脚本编写器（5个）",
  "tier_f_pro_5": "快速TAM逻辑草图",
  "tier_f_pro_6": "风险清单",
  "tier_f_pro_7": "功能优先级建议",
  "tier_f_pro_8": "供应商候选名单草稿",
  "tier_f_pro_9": "智能咨询会议（2小时）",
  "tier_f_pro_10": "12小时内优先支持",
  "tier_f_ent_1": "专业版所有内容",
  "tier_f_ent_2": "定制软件开发",
  "tier_f_ent_3": "企业广告策略",
  "tier_f_ent_4": "托管主机（12个月）",
  "tier_f_ent_5": "维护计划（6个月）",
  "tier_f_ent_6": "智能咨询（10小时）",
  "tier_f_ent_7": "国家进入检查",
  "tier_f_ent_8": "演示文稿执行摘要",
  "tier_f_ent_9": "JTBD问题陈述",
  "tier_f_ent_10": "专属客户经理",
  "tier_f_ent_11": "优先队列（4小时响应）",
  "calc_title": "价格计算器",
  "calc_subtitle": "比较单项服务与套餐价格，查看节省金额。",
  "calc_badge": "节省更多",
  "calc_select_services": "选择服务",
  "calc_search_placeholder": "搜索服务...",
  "calc_selected": "已选",
  "calc_your_selection": "您的选择",
  "calc_individual_total": "单项总计",
  "calc_best_tier": "最佳匹配套餐",
  "calc_you_save": "您节省",
  "calc_no_services": "选择服务以查看节省",
  "calc_clear_all": "全部清除",
  "calc_get_tier": "获取此套餐",
  "calc_individual_cheaper": "单项服务已经很划算。添加更多以解锁套餐优惠！",
  "referred_by": "推荐人",
  "referral_signup_reward": "注册以将您的账户与此推荐链接关联。",
  "badge_coming_soon": "即将推出",
  "badge_available_soon": "即将上线",
  "badge_from_price": "起价",
  "badge_preparing": "我们正在为您准备此服务",
  "svc_managed-hosting_label": "托管主机服务",
  "svc_managed-hosting_desc": "全面管理的主机服务，含监控与技术支持",
  "svc_enterprise-advertising_label": "企业广告",
  "svc_enterprise-advertising_desc": "大规模广告活动，配备专属策略",
  "svc_email-marketing_label": "邮件营销设置",
  "svc_email-marketing_desc": "专业邮件序列、模板和自动化",
  "svc_competitor-analysis_label": "竞争分析报告",
  "svc_competitor-analysis_desc": "市场情报和竞争定位",
  "svc_legal-docs_label": "法律文件生成器",
  "svc_legal-docs_desc": "NDA、合同、服务条款模板",
  "svc_website-audit_label": "网站审计与SEO报告",
  "svc_website-audit_desc": "全面的网站分析与可操作建议",
  "svc_trading-consultation_label": "交易咨询",
  "svc_trading-consultation_desc": "专家指导的交易策略会议",
  "svc_managed-trading_label": "托管交易",
  "svc_managed-trading_desc": "由专家管理的交易，采用经过验证的策略",
  "svc_domain-management_label": "域名管理",
  "svc_domain-management_desc": "域名注册、DNS管理和转移",
  "svc_personal-branding_label": "个人品牌",
  "svc_personal-branding_desc": "建立您的网络形象和个人品牌",
  "admin_escalation_alert": "聊天升级",
  "admin_view_escalations": "查看升级队列",
  "from": "起价",
  "vector_gen_title": "智能矢量",
  "vector_gen_title_hl": "生成器",
  "vector_gen_badge": "智能矢量工作室",
  "vector_gen_desc": "描述您的想法，上传参考文件，几秒钟内获得可用于生产的SVG矢量图形。",
  "vector_gen_balance": "您的余额",
  "vector_gen_per_gen": "每次生成的积分",
  "vector_gen_prompt_label": "描述您的矢量图形",
  "vector_gen_prompt_ph": "例如，一个带有阳光的极简山峰标志，使用青色和橙色...",
  "vector_gen_style": "风格",
  "vector_gen_color": "颜色模式",
  "vector_gen_refs": "参考文件",
  "vector_gen_optional": "可选，最多3个",
  "vector_gen_upload": "上传参考（PNG、JPG、SVG）",
  "vector_gen_generating": "生成中...",
  "vector_gen_cta": "生成矢量图",
  "vector_gen_result": "您的矢量图形",
  "vector_gen_model_used": "模型",
  "vector_gen_history": "生成历史",
  "vector_gen_no_history": "暂无生成记录",
  "vector_gen_login_req": "请登录以使用矢量生成器。",
  "vector_gen_service_title": "需要专业矢量图？",
  "vector_gen_service_desc": "订购定制矢量图形作为完整的设计服务，包括修改和品牌指南。",
  "vector_gen_service_cta": "查看设计服务",
  "vector_gen_product_type": "产品类型",
  "vector_gen_size": "输出尺寸",
  "vector_gen_error_prompt": "请描述您的矢量图形想法。",
  "admin_vector_gen": "矢量生成器",
  "admin_showroom": "展示厅",
  "admin_landing_page": "着陆页",
  "admin_landing_text": "着陆页文本",
  "admin_vector_title": "矢量生成器",
  "admin_vector_models": "可用模型",
  "admin_vector_pricing": "价格与限制",
  "svc_vector-generator_label": "智能矢量生成器",
  "svc_vector-generator_desc": "从文字描述生成可用于生产的SVG矢量图形",
  "sp_vector_gen_name": "智能矢量生成器",
  "sp_vector_gen_desc": "使用智能技术从文字描述生成可用于生产的SVG矢量图形。",
  "sp_vector_gen_feat": "文字转矢量生成|SVG和PNG导出|多种风格预设|内联SVG编辑器|参考文件上传|基于积分的定价",
  "sp_managed_hosting_name": "托管主机",
  "sp_managed_hosting_feat": "24/7监控|自动更新|SSL管理|每日备份|性能优化|专属支持",
  "sp_enterprise_ad_name": "企业广告",
  "sp_enterprise_ad_feat": "活动策略|多渠道|A/B测试|效果追踪|专属经理|报告",
  "sp_email_marketing_name": "邮件营销设置",
  "sp_email_marketing_feat": "邮件序列|模板设计|自动化|列表管理|分析|A/B测试",
  "sp_competitor_analysis_name": "竞争分析报告",
  "sp_competitor_analysis_feat": "市场分析|竞争对手画像|SWOT|价格比较|建议|更新",
  "sp_website_audit_name": "网站审计与SEO报告",
  "sp_website_audit_feat": "技术审计|SEO分析|性能指标|可访问性|安全扫描|行动计划",
  "sp_defi_name": "DeFi解决方案",
  "sp_defi_feat": "智能合约|流动性挖矿|流动性池|DeFi审计|代币创建|质押方案",
  "sp_personal_brand_name": "个人品牌",
  "sp_personal_brand_feat": "品牌策略|社交媒体形象|个人网站|内容规划|专业照片|简介撰写",
  "sp_ad_gen_name": "广告生成器",
  "sp_ad_gen_feat": "广告文案|创意格式|多平台|A/B变体|受众定位|效果建议",
  "sp_priority_name": "优先队列",
  "sp_priority_feat": "4小时回复|专属通道|优先处理|状态更新|SLA保障|扩展支持",
  "sp_maintenance_name": "维护计划",
  "sp_maintenance_feat": "每月更新|安全补丁|性能监控|错误修复|正常运行保障|优先支持",
  "sp_consulting_name": "智能咨询会议",
  "sp_consulting_feat": "专家咨询|策略会议|技术建议|实施计划|后续笔记|提供录音",
  "sp_market_snapshot_name": "市场快照",
  "sp_market_snapshot_feat": "市场概览|关键趋势|竞争格局|增长机会|风险因素|执行摘要",
  "sp_trend_explainer_name": "趋势解析",
  "sp_trend_explainer_feat": "趋势分析|行业影响|机会评估|时间预测|行动步骤|可视化报告",
  "sp_competitor_qa_name": "竞争对手问答",
  "sp_competitor_qa_feat": "策略分析|定价洞察|市场定位|功能比较|弱点分析|机会图谱",
  "sp_country_entry_name": "市场进入检查",
  "sp_country_entry_feat": "市场准备度|法规概览|文化因素|竞争分析|进入策略|风险评估",
  "sp_vendor_shortlist_name": "供应商短名单",
  "sp_vendor_shortlist_feat": "供应商调研|比较矩阵|价格分析|能力评估|推荐建议|联系方式",
  "sp_tam_logic_name": "TAM逻辑草图",
  "sp_tam_logic_feat": "TAM估算|SAM/SOM拆分|逻辑框架|数据来源|增长假设|可视化展示",
  "sp_positioning_name": "定位策略",
  "sp_positioning_feat": "市场定位|受众细分|价值主张|信息框架|差异化|竞争优势",
  "sp_managed_trading_name": "托管交易",
  "sp_managed_trading_feat": "投资组合管理|风险管理|经验证策略|定期报告|专属经理|市场分析",
  "sp_trading_consult_name": "交易咨询",
  "sp_trading_consult_feat": "一对一课程|策略开发|市场分析|风险评估|投资组合审查|专家指导",
  "sp_domains_name": "LiveDomain域名市场",
  "sp_domains_feat": "高级域名|二级市场交易|域名估值|转移支持|协商|域名组合管理",
  "sp_domain_mgmt_name": "域名管理",
  "sp_domain_mgmt_feat": "DNS管理|自动续期|转移支持|域名跟踪|SSL证书|Whois隐私",
  "sp_managed_hosting_desc": "全面托管主机，包含监控、更新和专属支持。",
  "sp_enterprise_ad_desc": "大规模广告活动，配有专属策略和管理。",
  "sp_email_marketing_desc": "专业邮件序列、模板和营销自动化。",
  "sp_competitor_analysis_desc": "深入的市场情报和竞争定位分析。",
  "sp_website_audit_desc": "全面的网站分析和可操作的改进建议。",
  "sp_managed_trading_desc": "由专家管理的交易，采用经验证的策略和风险管理。",
  "sp_trading_consult_desc": "专家指导的一对一交易策略课程。",
  "sp_domains_desc": "高级域名获取和二级市场交易。",
  "sp_domain_mgmt_desc": "DNS管理、续期、转移和域名组合管理。",
  "sp_defi_desc": "智能合约、流动性挖矿和流动性池解决方案。",
  "sp_personal_brand_desc": "建立您的在线形象和个人品牌。",
  "sp_ad_gen_desc": "即时生成高转化广告文案和创意。",
  "sp_priority_desc": "4小时内保证回复。",
  "sp_maintenance_desc": "持续维护、更新和技术支持。",
  "sp_consulting_desc": "与我们的智能技术专家进行一对一咨询。",
  "sp_market_snapshot_desc": "市场格局和趋势的快速概览。",
  "sp_trend_explainer_desc": "了解与您行业相关的新兴趋势。",
  "sp_competitor_qa_desc": "获取竞争对手策略的答案。",
  "sp_country_entry_desc": "评估国际扩张的市场准备度。",
  "sp_vendor_shortlist_desc": "针对您特定需求的精选供应商名单。",
  "sp_tam_logic_desc": "总可寻址市场估算及逻辑分析。",
  "sp_positioning_desc": "产品和受众定位策略分析。",
  "vector_gen_model": "模型",
  "vector_gen_quality": "质量级别",
  "svc_smart-resume_label": "智能简历生成器",
  "svc_smart-resume_desc": "由我们的智能系统打造的ATS优化简历",
  "svc_smart-business-plan_label": "智能商业计划生成器",
  "svc_smart-business-plan_desc": "包含财务和市场分析的完整商业计划",
  "svc_smart-seo-report_label": "智能SEO报告",
  "svc_smart-seo-report_desc": "带有可操作建议的自动化网站分析",
  "svc_smart-brand-kit_label": "智能Logo和品牌套件",
  "svc_smart-brand-kit_desc": "Logo概念、调色板、排版和社交媒体素材",
  "svc_smart-email-campaign_label": "智能邮件活动",
  "svc_smart-email-campaign_desc": "采用优化序列的智能邮件营销",
  "svc_smart-social-calendar_label": "社交媒体日历与分析",
  "svc_smart-social-calendar_desc": "30天智能生成帖子及互动策略",
  "svc_ad-generator_label": "广告生成器",
  "svc_ad-generator_desc": "即时生成高转化广告文案",
  "svc_smart-translation_label": "智能翻译服务",
  "svc_smart-translation_desc": "50+语言专业文件翻译",
  "svc_smart-video-script_label": "智能视频脚本撰写",
  "svc_smart-video-script_desc": "优化互动的YouTube、TikTok和广告脚本",
  "svc_priority-queue_label": "优先队列",
  "svc_priority-queue_desc": "4小时内保证回复",
  "svc_maintenance-plan_label": "维护计划",
  "svc_maintenance-plan_desc": "持续维护、更新和技术支持",
  "svc_smart-consulting_label": "智能咨询会议",
  "svc_smart-consulting_desc": "与我们的技术专家一对一咨询",
  "svc_market-snapshot_label": "市场快照",
  "svc_market-snapshot_desc": "市场格局快速概览",
  "svc_trend-explainer_label": "趋势解析",
  "svc_trend-explainer_desc": "了解您行业的新兴趋势",
  "svc_competitor-qa_label": "竞争对手问答",
  "svc_competitor-qa_desc": "获取竞争对手策略的答案",
  "svc_country-entry-check_label": "市场进入检查",
  "svc_country-entry-check_desc": "评估国际扩张的市场准备度",
  "svc_should-i-care_label": "相关性检查",
  "svc_should-i-care_desc": "评估趋势对您业务的重要性",
  "svc_report-matchmaker_label": "报告匹配器",
  "svc_report-matchmaker_desc": "找到合适的研究报告",
  "svc_which-region-first_label": "区域优先级",
  "svc_which-region-first_desc": "基于数据的区域市场进入指导",
  "svc_vendor-shortlist_label": "供应商短名单",
  "svc_vendor-shortlist_desc": "针对您需求的精选供应商名单",
  "svc_forecast-explanation_label": "预测解析",
  "svc_forecast-explanation_desc": "市场预测的清晰解释",
  "svc_outreach-email-gen_label": "外展邮件生成器",
  "svc_outreach-email-gen_desc": "大规模生成个性化外展邮件",
  "svc_executive-summary_label": "执行摘要",
  "svc_executive-summary_desc": "可用于演示的精简摘要",
  "svc_faq-answer-draft_label": "FAQ答案草稿",
  "svc_faq-answer-draft_desc": "起草常见客户问题的答案",
  "svc_jtbd-problem_label": "JTBD问题陈述",
  "svc_jtbd-problem_desc": "基于JTBD框架的问题分析",
  "svc_tam-logic-sketch_label": "TAM逻辑草图",
  "svc_tam-logic-sketch_desc": "总可寻址市场估算及逻辑拆解",
  "svc_risk-checklist_label": "风险检查清单",
  "svc_risk-checklist_desc": "全面的风险评估清单",
  "svc_feature-prioritization_label": "功能优先级排序",
  "svc_feature-prioritization_desc": "基于数据的功能优先级建议",
  "svc_next-research-question_label": "下一个研究问题",
  "svc_next-research-question_desc": "发现下一个关键研究问题",
  "svc_positioning-angle_label": "定位策略",
  "svc_positioning-angle_desc": "产品和受众定位策略分析",
  "svc_blog-outline-trend_label": "基于趋势的博客大纲",
  "svc_blog-outline-trend_desc": "将热门话题转化为结构化博客大纲",
  "admin_ai_reports": "AI服务报告",
  "admin_project_delivery": "987976ee4ea44ed8",
  "admin_analytics_digestadmin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "sp_managed_hosting": "[TRANSLATE] Managed Hosting",
  "sp_enterprise_ad": "[TRANSLATE] Enterprise Advertising",
  "sp_email_marketing": "[TRANSLATE] Email Marketing Setup",
  "sp_competitor_analysis": "[TRANSLATE] Competitor Analysis Report",
  "sp_website_audit": "[TRANSLATE] Website Audit & SEO Report",
  "sp_managed_trading": "[TRANSLATE] Managed Trading",
  "sp_trading_consult": "[TRANSLATE] Trading Consultations",
  "sp_domains": "[TRANSLATE] LiveDomain Aftermarket",
  "sp_domain_mgmt": "[TRANSLATE] Domain Management",
  "sp_defi": "[TRANSLATE] DeFi Solutions",
  "sp_personal_brand": "[TRANSLATE] Personal Branding",
  "sp_ad_gen": "[TRANSLATE] Ad Generator",
  "sp_priority": "[TRANSLATE] Priority Queue",
  "sp_maintenance": "[TRANSLATE] Maintenance Plan",
  "sp_consulting": "[TRANSLATE] Smart Consulting Session",
  "sp_market_snapshot": "[TRANSLATE] Market Snapshot",
  "sp_trend_explainer": "[TRANSLATE] Trend Explainer",
  "sp_competitor_qa": "[TRANSLATE] Competitor Q&A",
  "sp_country_entry": "[TRANSLATE] Country Entry Check",
  "sp_vendor_shortlist": "[TRANSLATE] Vendor Shortlist Draft",
  "sp_tam_logic": "[TRANSLATE] Quick TAM Logic Sketch",
  "sp_positioning": "[TRANSLATE] Positioning Angle",
  "agency_rista_tooltip": "与RisTA聊天",
  "agency_hero_title_1": "为本地企业打造的",
  "agency_hero_title_highlight": "高转化",
  "agency_hero_title_2": "闪电级网站",
  "agency_hero_subtitle_1": "获取毫秒级加载的定制网站 + 内置分析功能，仅需",
  "agency_hero_subtitle_2": "。告别慢页面，更多潜在客户 — 数周内上线。",
  "agency_hero_limited": "名额有限！",
  "agency_hero_cta_pricing": "查看€498套餐",
  "agency_hero_cta_audit": "免费审计",
  "agency_trust_maintenance": "之后维护",
  "agency_trust_efficient": "100%高效",
  "agency_trust_powered": "智能系统驱动",
  "agency_speed_title": "网站加载速度",
  "agency_speed_before": "之前",
  "agency_speed_after": "之后",
  "agency_speed_leads": "+35%潜在客户",
  "agency_pain_title_1": "慢速网站",
  "agency_pain_title_2": "扼杀销售",
  "agency_pain_subtitle": "网站每多加载一秒，您就会失去客户。这就是问题所在 — 以及我们如何解决。",
  "agency_pain_slow_title": "加载慢 = 丢失潜在客户",
  "agency_pain_slow_desc": "您的网站加载需要5秒以上。访客在看到您的产品之前就离开了。",
  "agency_pain_stats_title": "47%在>3秒时离开",
  "agency_pain_stats_desc": "Google研究表明，近一半的访客会放弃加载超过3秒的移动网站。",
  "agency_pain_stats_source": "来源：Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "我们的Speed-First技术",
  "agency_pain_solution_desc": "定制网站优化到1秒内加载。边缘缓存、图片优化、代码最小化。更快=更多客户=更多收入。",
  "agency_pricing_title": "简单透明的定价",
  "agency_pricing_subtitle": "选择适合您业务的方案。所有方案都包含我们的Speed-First技术。",
  "agency_pricing_urgency_1": "本月仅剩",
  "agency_pricing_urgency_2": "个入门名额",
  "agency_pricing_popular": "最受欢迎",
  "agency_pricing_get_started": "立即开始",
  "agency_pricing_guarantee": "30天退款保证",
  "agency_pricing_ideal": "适合：",
  "agency_pricing_starter": "入门版",
  "agency_pricing_onetime": "一次性",
  "agency_pricing_starter_ideal": "个人创业者",
  "agency_pricing_s_1": "闪电级定制网站",
  "agency_pricing_s_2": "域名 + 1年托管",
  "agency_pricing_s_3": "基础分析仪表盘",
  "agency_pricing_s_4": "移动端响应式设计",
  "agency_pricing_s_5": "SSL证书包含",
  "agency_pricing_performance": "性能版",
  "agency_pricing_perf_ideal": "成长中的店铺",
  "agency_pricing_p_1": "入门版全部内容",
  "agency_pricing_p_2": "电子商务 + 购物车恢复",
  "agency_pricing_p_3": "SEO优化套餐",
  "agency_pricing_p_4": "A/B测试集成",
  "agency_pricing_p_5": "优先支持",
  "agency_pricing_premium": "高级版",
  "agency_pricing_prem_ideal": "扩展中的企业",
  "agency_pricing_pr_1": "性能版全部内容",
  "agency_pricing_pr_2": "Google Ads管理",
  "agency_pricing_pr_3": "每周性能审计",
  "agency_pricing_pr_4": "专属客户经理",
  "agency_pricing_pr_5": "定制集成",
  "agency_social_title": "本地企业的信赖之选",
  "agency_social_rista_label": "RisTA AI：",
  "agency_social_rista_quote": "我实时分析访客行为，提升您的转化率。",
  "agency_social_see_clients": "看看我们的客户怎么说",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO，本地商店",
  "agency_social_t1_text": "第一个月潜在客户翻倍！网站瞬间加载，客户喜欢新设计。",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "餐厅老板",
  "agency_social_t2_text": "新网站上线后，在线订单增长了40%。速度差异天壤之别。",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "健身工作室",
  "agency_social_t3_text": "专业、快速，信守承诺。预订率在3周内提升了35%。",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "精品店店主",
  "agency_social_t4_text": "电商设置无缝衔接。仅购物车恢复功能就在第一季度收回了性能版的成本。",
  "agency_social_metric_1": "平均加载时间",
  "agency_social_metric_2": "更多潜在客户",
  "agency_social_metric_3": "客户满意度",
  "agency_services_title": "您的业务所需的一切",
  "agency_services_subtitle": "全面的数字解决方案，助力您的在线业务增长。",
  "agency_svc_fast_title": "快速网站",
  "agency_svc_fast_desc": "定制网站1秒内加载。移动优先，SEO优化，转化导向。",
  "agency_svc_ecom_title": "电商商店",
  "agency_svc_ecom_desc": "在线销售，配备购物车恢复、支付处理和库存管理。",
  "agency_svc_seo_title": "SEO审计与优化",
  "agency_svc_seo_desc": "在Google排名更高。技术SEO、内容策略和月度报告。",
  "agency_svc_ads_title": "Google Ads设置",
  "agency_svc_ads_desc": "快速获取精准流量。包含广告活动设置、优化和ROI跟踪。",
  "agency_svc_maint_title": "维护与支持",
  "agency_svc_maint_desc": "托管、安全更新、备份和内容更改。每月€30起。",
  "agency_faq_title": "常见问题",
  "agency_faq_q1": "我的网站加载速度有多快？",
  "agency_faq_a1": "不到1秒。我们优化每一毫秒 — 从服务器响应到完整视觉渲染。",
  "agency_faq_q2": "€498入门套餐包含什么？",
  "agency_faq_a2": "闪电级定制网站、1年域名和托管、基础分析仪表盘、移动响应设计和SSL证书。",
  "agency_faq_q3": "上线需要多长时间？",
  "agency_faq_a3": "大多数入门项目在2-3周内上线。性能版和高级版通常需要4-6周。",
  "agency_faq_q4": "你们提供持续维护吗？",
  "agency_faq_a4": "是的。第一年后，维护费每月€30起，包括托管、安全更新、备份和小幅内容更改。",
  "agency_faq_q5": "以后可以升级方案吗？",
  "agency_faq_a5": "当然可以。您可以随时从入门版升级到性能版或高级版。我们会抵扣您的初始投资。",
  "agency_cta_title_1": "准备好无限",
  "agency_cta_title_2": "扩展了吗？",
  "agency_cta_subtitle": "告诉我们您的业务，我们将制定定制计划。免费咨询，无任何义务。",
  "agency_contact_name": "您的姓名",
  "agency_contact_email": "电子邮件地址",
  "agency_contact_biz_select": "选择业务类型",
  "agency_contact_biz_restaurant": "餐饮",
  "agency_contact_biz_retail": "零售/商店",
  "agency_contact_biz_services": "专业服务",
  "agency_contact_biz_fitness": "健身/健康",
  "agency_contact_biz_realestate": "房地产",
  "agency_contact_biz_other": "其他",
  "agency_contact_submit": "获取免费咨询",
  "agency_contact_sent_title": "消息已发送！",
  "agency_contact_sent_desc": "我们将在24小时内回复您。",
  "agency_exit_title": "等一下！免费速度审计？",
  "agency_exit_desc": "了解您的网站可以快多少。获取详细性能报告 — 100%免费。",
  "agency_exit_email": "您的邮箱",
  "agency_exit_submit": "发送审计",
  "agency_exit_thanks_title": "谢谢！",
  "agency_exit_thanks_desc": "我们将在24小时内发送免费速度审计。",
  "agency_footer_brand_desc": "由Infinitybusiness.org开发、托管和设计",
  "agency_footer_services": "服务",
  "agency_footer_fast_web": "快速网站",
  "agency_footer_ecom": "电商商店",
  "agency_footer_seo": "SEO审计",
  "agency_footer_ads": "Google Ads设置",
  "agency_footer_maint": "维护",
  "agency_footer_company": "公司",
  "agency_footer_about": "关于我们",
  "agency_footer_contact": "联系方式",
  "agency_footer_privacy": "隐私政策",
  "agency_footer_terms": "条款与条件",
  "agency_footer_touch": "联系我们",
  "agency_footer_copyright": "© 2026 Infinity Business. 保留所有权利。",
  "agency_footer_dev_by": "由以下公司开发、托管和设计",
  "agency_footer_newsletter": "订阅新闻通讯",
  "agency_footer_subscribe": "订阅",
  "agency_sticky_pricing": "查看定价",
  "showroom_page_title": "展示厅",
  "showroom_meta_desc": "探索我们的网站改造作品集。真实客户项目的前后对比。",
  "showroom_badge": "我们的作品",
  "showroom_title_prefix": "项目",
  "showroom_title_highlight": "展示厅",
  "showroom_subtitle": "查看真实的改造案例。拖动滑块比较我们客户项目的前后状态。",
  "showroom_search_placeholder": "搜索项目...",
  "showroom_all_services": "所有服务",
  "showroom_sort_newest": "最新优先",
  "showroom_sort_oldest": "最旧优先",
  "showroom_sort_name_az": "名称 A-Z",
  "showroom_sort_name_za": "名称 Z-A",
  "showroom_active_filters": "活动筛选",
  "showroom_showing": "显示",
  "showroom_project_singular": "个项目",
  "showroom_project_plural": "个项目",
  "showroom_empty": "展示厅暂无项目。",
  "showroom_no_match": "没有项目符合您的筛选条件。",
  "showroom_features_built": "已构建功能",
  "showroom_visit_live": "访问在线站点"
};
